// Function to adjust font size to prevent text overflow in circular elements
function adjustFontSizeForCircularElement(
  element: HTMLElement,
  minFontSize: number = 8,
): void {
  const originalFontSize = parseFloat(getComputedStyle(element).fontSize);
  let currentFontSize = originalFontSize;

  // Reset to original size first
  element.style.fontSize = `${originalFontSize}px`;

  // Check if text is overflowing
  const isOverflowing = (): boolean => {
    const rect = element.parentElement?.getBoundingClientRect();

    // For circular elements, check if text exceeds the container dimensions
    const containerWidth = rect.width - 20;
    const containerHeight = rect.height - 20;

    // These account for the actual rendered size including positioning
    const textWidth = element.offsetWidth;
    const textHeight = element.offsetHeight;

    return textWidth > containerWidth || textHeight > containerHeight;
  };

  // Reduce font size until text fits
  while (isOverflowing() && currentFontSize > minFontSize) {
    currentFontSize -= 2;
    element.style.fontSize = `${currentFontSize}px`;
  }
}

// Function to handle all circular elements with text
function handleCircularTextOverflow(): void {
  const circularElements = document.querySelectorAll('.js-circular-text');

  circularElements.forEach((el) => {
    if (el instanceof HTMLElement) {
      adjustFontSizeForCircularElement(el);
    }
  });
}

// Run on DOM content loaded
document.addEventListener('DOMContentLoaded', handleCircularTextOverflow);

// Also run when window is resized to handle dynamic content
window.addEventListener('resize', handleCircularTextOverflow);
